import styled from '@emotion/styled';
import {
  ClearIconContainer,
  CoupleSearchAddOn,
} from '@zola/zola-ui/src/components/Form/inputV3/InputFieldV3/InputFieldV3.styles';
import COLORS3 from '@zola/zola-ui/src/styles/emotion/colors3';
import FONT from '@zola/zola-ui/src/styles/emotion/fonts';
import MEDIA_QUERY_V2 from '@zola/zola-ui/src/styles/emotion/mediaQueryV2';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';
import H from '@zola/zola-ui/src/typography/Headings';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${SPACING.S32} ${SPACING.S24};
  ${MEDIA_QUERY_V2.DESKTOP} {
    align-items: center;
    padding: 64px 0;
  }
  ${MEDIA_QUERY_V2.DESKTOP_XL} {
    padding: 72px 0;
  }
`;

export const StyledH1 = styled(H.Title1)`
  margin-bottom: ${SPACING.S32};
  ${MEDIA_QUERY_V2.MOBILE} {
    font-size: ${FONT.FONT_SIZE_LARGER};
    max-width: 325px;
    margin-bottom: ${SPACING.S16};
  }
  ${MEDIA_QUERY_V2.TABLET} {
    font-size: 42px !important;
  }
  ${MEDIA_QUERY_V2.DESKTOP} {
    font-size: ${FONT.FONT_SIZE_SEMI_HUGE} !important;
  }
  ${MEDIA_QUERY_V2.DESKTOP_XL} {
    font-size: 64px !important;
  }
`;

export const StyledH2 = styled(H.Title2)`
  margin-bottom: ${SPACING.S32};
  ${MEDIA_QUERY_V2.MOBILE} {
    margin-bottom: ${SPACING.S16};
    font-size: ${FONT.FONT_SIZE_SMALL};
  }
  ${MEDIA_QUERY_V2.TABLET} {
    font-size: 18px;
  }
`;

export const InputWrapper = styled.div`
  ${MEDIA_QUERY_V2.MOBILE} {
    display: flex;
    flex-direction: column;
    row-gap: 16px;
    width: 100%;
  }
  ${MEDIA_QUERY_V2.EXCLUDE_MOBILE} {
    margin: auto;
  }
  input {
    border-radius: 100px;
    background-color: ${COLORS3.BLACK_005};
    border: none;
    height: 56px;
    padding: ${SPACING.S16} ${SPACING.S24};
    padding-left: 50px !important;

    ${MEDIA_QUERY_V2.EXCLUDE_MOBILE_XS} {
      width: 389px;
    }
  }

  ${CoupleSearchAddOn} {
    top: 16px;
    left: 20px;
    width: 24px !important;
    height: 24px !important;
  }

  ${ClearIconContainer} {
    top: 22px;
    right: 18px;
  }

  button {
    margin-left: ${SPACING.XS};

    ${MEDIA_QUERY_V2.MOBILE} {
      align-self: flex-start;
      margin-left: 0;
    }
  }
`;
